import React, { useState } from "react";
import { SwipeProvider } from "./SwipeProvider";
import Carousel from "../Tabs/Carousel";

const ExampleCarouselUsage: React.FC = () => {
	interface SlideData {
		id: number;
		title: string;
		imageUrl: string;
		description: string;
	}

	// Sample data
	const slides: SlideData[] = [
		{
			id: 1,
			title: "Mountain View",
			imageUrl: "/api/placeholder/800/400",
			description: "A beautiful mountain landscape"
		},
		{
			id: 2,
			title: "Beach Sunset",
			imageUrl: "/api/placeholder/800/400",
			description: "Relaxing sunset at the beach"
		},
		{
			id: 3,
			title: "City Skyline",
			imageUrl: "/api/placeholder/800/400",
			description: "Urban architecture at night"
		},
		{
			id: 4,
			title: "Forest Trail",
			imageUrl: "/api/placeholder/800/400",
			description: "A serene path through the woods"
		}
	];

	// Define how each slide should be rendered
	const renderSlide = (slide: SlideData) => (
		<div className="max-w-xl">
			<div className="bg-primary-background text-primary-active p-4">
				<h3 className="text-xl font-bold">{slide.title}</h3>
				<p>{slide.description}</p>
			</div>
		</div>
	);

	return (
		<div className="max-w-2xl mx-auto my-2 text-primary-active bg-blue-200">
			<h2 className="text-2xl font-bold mb-4">Example Carousel</h2>
			<Carousel
				slides={slides}
				onRenderSlide={renderSlide}
				className="rounded-lg shadow-lg overflow-hidden"
			/>
		</div>
	);
};

// Demo component showing the swipe functionality
const SwipeXDemo: React.FC = () => {
	// eslint-disable-next-line
	const [swipeCount, setSwipeCount] = useState({ left: 0, right: 0 });
	// eslint-disable-next-line
	const [message, setMessage] = useState("Swipe to get started!");

	// const handleSwipeLeft = () => {
	// 	setSwipeCount((prev) => ({ ...prev, left: prev.left + 1 }));
	// 	setMessage("Swiped Left! 👈");
	// 	setTimeout(() => setMessage("Swipe again!"), 1500);
	// };

	// const handleSwipeRight = () => {
	// 	setSwipeCount((prev) => ({ ...prev, right: prev.right + 1 }));
	// 	setMessage("Swiped Right! 👉");
	// 	setTimeout(() => setMessage("Swipe again!"), 1500);
	// };

	return (
		<div style={{ padding: "20px", maxWidth: "600px", margin: "0 auto" }}>
			<h2 style={{ textAlign: "center", marginBottom: "30px" }}>
				Swipe Gesture Component Demo
			</h2>

			<div style={{ marginBottom: "20px" }}>
				<SwipeProvider swipeThreshold={12} velocityThreshold={0.25}>
					<div className="border-2 border-red-500">
						<div style={{ textAlign: "center" }}>
							<h3 style={{ margin: "0 0 10px 0", color: "#333" }}>{message}</h3>
							<p style={{ margin: 0, color: "#666" }}>
								Use mouse or touch to swipe horizontally
							</p>
						</div>

						<ExampleCarouselUsage />
					</div>
				</SwipeProvider>
			</div>

			<div
				style={{
					display: "grid",
					gridTemplateColumns: "1fr 1fr",
					gap: "20px",
					marginTop: "20px"
				}}
			>
				<div
					style={{
						padding: "15px",
						backgroundColor: "#ffe6e6",
						borderRadius: "8px",
						textAlign: "center"
					}}
				>
					<h4 style={{ margin: "0 0 5px 0", color: "#e74c3c" }}>
						← Left Swipes
					</h4>
					<span style={{ fontSize: "24px", fontWeight: "bold" }}>
						{swipeCount.left}
					</span>
				</div>

				<div
					style={{
						padding: "15px",
						backgroundColor: "#e6ffe6",
						borderRadius: "8px",
						textAlign: "center"
					}}
				>
					<h4 style={{ margin: "0 0 5px 0", color: "#27ae60" }}>
						Right Swipes →
					</h4>
					<span style={{ fontSize: "24px", fontWeight: "bold" }}>
						{swipeCount.right}
					</span>
				</div>
			</div>

			<div
				style={{
					marginTop: "30px",
					padding: "15px",
					backgroundColor: "#f8f9fa",
					borderRadius: "8px",
					fontSize: "14px",
					color: "#666"
				}}
			>
				<h4 style={{ margin: "0 0 10px 0", color: "#333" }}>Usage:</h4>
				<pre style={{ margin: 0, overflow: "auto" }}>
					{`
// 1. Create context and provider
const SwipeContext = createContext<SwipeContextType | null>(null);

// 2. Use hook in deeply nested component
const { registerSwipeHandlers } = useSwipeActions();

// 3. Register your handlers
useEffect(() => {
  registerSwipeHandlers(
    () => handleLeftSwipe(),
    () => handleRightSwipe()
  );
}, []);`}
				</pre>
			</div>
		</div>
	);
};

export default SwipeXDemo;
